import { render, staticRenderFns } from "./CategoryWithStatus.vue?vue&type=template&id=bfaa666a&"
import script from "./CategoryWithStatus.vue?vue&type=script&lang=js&"
export * from "./CategoryWithStatus.vue?vue&type=script&lang=js&"
import style0 from "./CategoryWithStatus.vue?vue&type=style&index=0&id=bfaa666a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports